import { render, staticRenderFns } from "./InfoTileList.vue?vue&type=template&id=966546ec&"
import script from "./InfoTileList.vue?vue&type=script&lang=js&"
export * from "./InfoTileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports